import React, {useEffect, useState} from "react"
import {IPagesProps} from "../../../contracts/pages";
import Table from "../../Elements/Table";
import useToastNotify from "../../../hook/useToastNotify";
import TableTd from "../../Elements/Table/TableTd";
import Badge from "../../Elements/Badge";
import {badgeType, contactUsType} from "../../../constans/enumTypes";
import TableTr from "../../Elements/Table/TableTr";
import httpClient from "../../../services/httpClient";
import {videoProductApi} from "../../../constans/apiUrls";
import MyPagination from "../../Elements/MyPagination";
import TableTdContent from "../../Elements/Table/TableTdContent";
import TableEmpty from "../../Elements/Table/TableEmpty";
import {MdCheck, MdOutlineSettingsBackupRestore} from "react-icons/md";
import MenuDrop from "../../Elements/MenuDrop";
import MenuDropItem from "../../Elements/MenuDrop/MenuDropItem";
import {IVideoProductCounselingData} from "../../../contracts/data/video_product";

const ListCounseling: React.FC<IPagesProps> = () => {
    const {toastNotify} = useToastNotify();
    const [data, setData] = useState<Array<IVideoProductCounselingData>>([]);
    const [page, setPage] = useState<number>(1);
    const [countItems, setCountItems] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [reload, setReload] = useState<boolean>(false);

    const titleHeadTable: Array<string> = ['#', 'نام و نام خانوادگی', 'عنوان دوره', 'شماره تماس', 'وضعیت', 'عملیات']

    const fetchItemsData = async (search: string | null | undefined = "") => {
        await httpClient().get(`${videoProductApi.counseling_list}?page=${page}`, {params: {search}})
            .then(response => {
                if (response.status === 200) {
                    setCountItems(response.data.count)
                    setData(response.data.results)
                }
            })
            .catch(error => toastNotify('error', 'مشکلی در دریافت لیست آیتم ها وجود دارد'))
            .finally(() => setLoading(false))
    }

    const handleSearchItems = async (search: string | null | undefined = "") => {
        setLoading(true)
        setPage(1)
        fetchItemsData(search)
    }

    const handleChangeStatusItem = async (id: number, index: number, status: contactUsType) => {
        await httpClient().put(videoProductApi.counseling_status, {counseling: id, status: status})
            .then(response => {
                if (response.status === 200) {
                    data[index].status = status
                    setReload(true)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    useEffect(() => {
        fetchItemsData()
    }, [page])

    useEffect(() => {
        if (reload) {
            setReload(false)
        }
    }, [reload])

    const itemsTableRows = data.map((item, index) =>
        <TableTr key={`table-row${index}`}>
            <TableTd><TableTdContent content={`${index + 1}`}/></TableTd>
            <TableTd><TableTdContent content={item?.name} isPrimary/></TableTd>
            <TableTd><TableTdContent content={item?.video_title} isPrimary/></TableTd>
            <TableTd><TableTdContent content={item?.phone}/></TableTd>
            <TableTd>
                <Badge title={item?.status === contactUsType.CHECK ? "بررسی" : (item?.status === contactUsType.REFOLLOW ? "تماس مجدد" : "انجام شد")}
                       typeBadge={item?.status === contactUsType.CHECK ? badgeType.warning : (item?.status === contactUsType.REFOLLOW ? badgeType.info : badgeType.success)}
                />
            </TableTd>
            <TableTd>
                <MenuDrop>
                    <MenuDropItem title={"تماس مجدد"} icon={<MdOutlineSettingsBackupRestore/>}
                                  handleOnSubmit={() => handleChangeStatusItem(item?.id, index, contactUsType.REFOLLOW)}/>
                    <MenuDropItem title={"انجام شد"} icon={<MdCheck/>}
                                  handleOnSubmit={() => handleChangeStatusItem(item?.id, index, contactUsType.DONE)}/>
                </MenuDrop>
            </TableTd>
        </TableTr>
    )

    return (
        <React.Fragment>
            <Table isLoading={loading} title={'لیست مشاوره ها'} subTitle={`تعداد کل: ${countItems}`}
                   titlesTable={titleHeadTable} isSearch={true} handleSearch={handleSearchItems}>
                {itemsTableRows.length > 0 ? itemsTableRows :
                    <TableEmpty colSpan={titleHeadTable.length} message={"موردی یافت نشد"}/>}
            </Table>
            <div className={"text-right"}>
                <MyPagination countItems={countItems} page={page} handleChangePage={setPage}/>
            </div>
        </React.Fragment>
    )
}

export default ListCounseling